module.exports = __webpack_public_path__ + "cf1683a4a816b3def976b8e5dab52a72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg3.jpg
// module id = 172
// module chunks = 1